import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { type IncidentStatuses } from '../../../../core/types/incident-statuses.type';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IncidentStatusesService {
  private readonly http = inject(HttpClient);

  load(): Observable<IncidentStatuses> {
    return this.http.get<IncidentStatuses>(`api/v1/tickets/workup/current/status`);
  }
}
